import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ImageGalleryImage, WebsiteData } from '../state-management/model/interfaces/state.model';
import { FirestoreService } from './firestore.service';

@Injectable({
  providedIn: 'root'
})

export class WebsiteService {
  private website: WebsiteData | null = null;
  private imageGallery: ImageGalleryImage[] | null = null;

  constructor(
    private fireStoreService: FirestoreService
  ) { }

  // Website DATA
  async loadWebsiteData(): Promise<WebsiteData | null> {
    try {
      return this.#loadWebsiteDataBrowser();
    } catch (err) {
      console.error('Fehler beim Laden der Website-Daten:', err);
      return null;
    }
  }


  // Image Gallery DATA
  async loadImageGalleryData(): Promise<ImageGalleryImage[] | null> {
    try {
      return this.#loadImageGalleryDataBrowser();
    } catch (err) {
      console.error('Fehler beim Laden der Website-Daten:', err);
      return null;
    }
  }

  // Private methods
  async #loadWebsiteDataBrowser(): Promise<WebsiteData | null> {
    try {
      return this.fireStoreService.getWebsiteData();
    } catch (err) {
      console.error('Fehler beim Laden der Website-Daten', err);
      return null;
    }
  }

  async #loadImageGalleryDataBrowser(): Promise<ImageGalleryImage[] | null> {
    try {
      return this.fireStoreService.getImageGallery();
    } catch (err) {
      console.error('Fehler beim Laden der Image Gallery Data', err);
      return null;
    }
  }
}